import type { FloorBay, FloorSplitData } from "building-types/floors/floorSplitDataTypes";
import type { Table } from "common/data/table";

/** Doc split data: bays exist only when at least one split line is present. */
export function normalizeFloorSplitData(splitData: FloorSplitData | undefined): FloorSplitData | undefined {
  if (!splitData) {
    return undefined;
  }
  if (Object.keys(splitData.splitLines).length === 0) {
    return undefined;
  }
  return splitData;
}

export function floorSplitDataWithReconciledBays(
  splitData: FloorSplitData,
  bays: Table<FloorBay>,
): FloorSplitData | undefined {
  return normalizeFloorSplitData({ ...splitData, bays });
}
